<template>
  <div class="container">
    <div class="content-i">
      <div class="content-box">
          <div class="row justify-content-center">
            <div class="col">
              <div class="element-wrapper">
              
                <h3 class="element-header">
                  Cadastro 
                </h3>
                <div class="element-box">
                  <form>
                      <div class="steps-w">
                        <div class="step-triggers">
                            <a class="step-trigger active" href="#stepContent1">Usuário Dr.Achei Card?</a><a class="step-trigger" href="#stepContent2">Dados Titular</a><a class="step-trigger" href="#stepContent3">Confirmação</a>
                        </div>
                        <div class="step-contents">
                            <div class="step-content active" id="stepContent1">
                                <div class="form-row">
                                  <form class="col-md-8 offset-md-2">
                                      <h5 class="form-head">Possui Dr.Achei Card?</h5>
                                      <div class="form-desc">
                                          Caro cliente, caso você possua Dr.Achei Card poderá contar com todos os benefícios do cartão no site.
                                      </div>
                                      <div class="text-center">
                                          <router-link :to="{name: 'Cadastrese-sinsaude'}" class="btn btn-lg btn-primary">SIM</router-link>
                                          <router-link :to="{name: 'Cadastrese-usuarioDrAchei'}" class="btn btn-lg btn-primary">NÃO</router-link>
                                      </div>
                                  </form>
                                </div>
                              <div class="form-buttons-w text-right">
                              <a class="btn btn-primary step-trigger-btn" href="#stepContent2"> Continuar</a>
                              </div>
                          </div>
                          <div class="step-content" id="stepContent2">
                              <div class="row justify-content-center">
                                <div class="col">
                                  <div class="element-wrapper">
                                    <div class="col-md-8 offset-md-2">
                                      <form @submit.prevent="salvar">
                                        <h5 class="form-head">
                                            Defina os dados de acesso.
                                        </h5>
                                        <div class="form-desc">
                                            Lembre-se seus dados de acesso é de uso pessoal e instransferível.
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col">
                                            <label for="username">Nome</label>
                                              <input type="text" name="name" id="name"
                                                v-model="payload.name" required
                                                class="form-control">
                                          </div>
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col-md-6">
                                            <label for="username">CPF</label>
                                              <input type="text" name="cpf" id="cpf"
                                                v-mask="'###.###.###-##'"
                                                v-model="payload.cpf" required
                                                class="form-control">
                                          </div>
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col-md-6">
                                            <div class="form-group">
                                              <label for="email">Email</label>
                                              <input type="email" name="email" id="email"
                                                v-model="payload.email" required
                                                class="form-control" aria-describedby="helpId">
                                            </div>
                                          </div>
                                          <div class="form-group col-md-6">
                                            <div class="form-group">
                                              <label for="celular">Celular</label>
                                              <input type="tel" name="celular" id="celular"
                                                v-model="payload.telefoneCelular" required
                                                v-mask="['(##) ####-####', '(##) #####-####']"
                                                class="form-control" aria-describedby="helpId">
                                            </div>
                                          </div>
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col">
                                            <label for="username">Usuario</label>
                                              <input type="text" name="username" id="username"
                                                v-model="payload.username" required
                                                class="form-control" aria-describedby="helpId">
                                          </div>
                                        </div>
                                        <div class="form-row">
                                          <div class="form-group col">
                                            <label for="senha">Senha</label>
                                              <input type="password" name="senha" id="senha"
                                                v-model="payload.password" required
                                                class="form-control" aria-describedby="helpId">
                                          </div>
                                          <div class="form-group col">
                                            <label for="repeteSenha">Repetir Senha</label>
                                              <input type="password" name="repeteSenha" id="repeteSenha"
                                                v-model="repeteSenha" required
                                                class="form-control" aria-describedby="helpId">
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="form-buttons-w text-right">
                              <a class="btn btn-primary step-trigger-btn" href="#stepContent3"> Continuar</a>
                              </div>
                          </div>
                          <div class="step-content" id="stepContent3">
                              <div class="form-row">
                                <form>
                                  <h5 class="form-head">Confime seu número de celular.</h5>
                                  <p class="form-desc">Enviamos um SMS com o código de validação.</p>
                                  <div class="form-group">
                                    <label for="codigo">Código</label>
                                    <input required v-model="payload.codigo" type="text" class="form-control" name="codigo" placeholder="Digite o código" id="codigo">
                                  </div>
                                </form>
                              </div>
                              <div class="form-buttons-w">
                                  <button type="submit" class="btn btn-primary">Validar e Finalizar Cadastro</button>
                              </div>
                          </div>
                      </div>
                      </div>
                  </form>
              </div>
              </div>
            </div>  
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      repeteSenha: null,
      payload: {
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
    }
  },
  mounted () {
    // #7. FORM STEPS FUNCTIONALITY
    window.jQuery('.step-trigger-btn').on('click', function () {
      var btnHref = window.jQuery(this).attr('href')
      window.jQuery('.step-trigger[href="' + btnHref + '"]').click()
      return false
    })
    // FORM STEP CLICK
    window.jQuery('.step-trigger').on('click', function () {
      var prevTrigger = window.jQuery(this).prev('.step-trigger')
      if (prevTrigger.length && !prevTrigger.hasClass('active') && !prevTrigger.hasClass('complete')) return false
      var contentId = window.jQuery(this).attr('href')
      window.jQuery(this).closest('.step-triggers').find('.step-trigger').removeClass('active')
      window.jQuery(this).prev('.step-trigger').addClass('complete')
      window.jQuery(this).addClass('active')
      window.jQuery('.step-content').removeClass('active')
      window.jQuery('.step-content' + contentId).addClass('active')
      return false
    })
    // END STEPS FUNCTIONALITY
  },
  methods: {
    goPergunta () {
      this.window.jQueryrouter.push({name: 'Cadastrese-pergunta'})
    },
    clear () {
      this.payload = {
        name: null,
        cpf: null,
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
      this.repeteSenha = null
    },
    salvar () {
      if (this.repeteSenha === this.payload.password) {
        this.payload.role = 'DRACHEI'
        this.window.jQuerystore.dispatch('saveUserDrAchei', this.payload)
          .then((usr) => {
            this.clear()
            this.window.jQuerystore.dispatch('setNomeUsuario', usr.name)
            this.window.jQueryrouter.push({name: 'Cadastrese-ativacao'})
          })
      } else {
        this.window.jQuerytoasted.show('As senhas não correspondem', {
          icon: { name: 'fa-exclamation-triangle' },
          type: 'error',
          theme: 'bubble',
          action: {
            text: 'FECHAR',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          }
        })
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/cadastrese/CadastroWizard.vue